import React from 'react';
import fundo from '../Imagens/fundo login.png';
import '../Estilos/EstiloBotao.css';
import '../Estilos/Container.css';
import '../Estilos/Fontes.css';
import '../Estilos/Componentes.css';

export default function ImagemDiv() {
  return (
    <div className="ImagemLogin">
      <img src={fundo} id="ImagemLogin" />
    </div>
  );
}
